(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/start/start.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/start/start.js');
'use strict';

const {
  StartPage
} = svs.arena.shared.components;
const Start = () => React.createElement(StartPage, null);
svs.arena.pages.Start = Start;

 })(window);